/* Turning a bot's line code into something to draw.

   The socket carries a **code, never a sentence** — see the backend's `games/bot_talk.py`: a
   server that sent the words would send Spanish to an English player, and would be one release
   from being a channel for arbitrary strings. That is the same split `reactions.js` uses for a
   player's gesture and `errorMessages.js` for a refusal, for the same reason.

   These were chat lines until 2026-09-09, and they read wrong there: the chat is where the players
   talk to each other, and a bot posting sentences into it — with a coordinate button, in the same
   typeface as a teammate's message — was a bot pretending to be one of them. They are reactions
   now, so they draw in the same bubble as a player's, live for four seconds and go.

   Two things follow from being a bubble rather than a line of chat. The **cell is gone**: it
   travelled in the text because the chat turns a coordinate into a button that flies the map
   there, and a bubble in the middle of the map has nothing to make clickable — what would be left
   is a location read out to whoever is nearest. And the words are **per side**: a growl is not
   something a human bot says, so `botLines.zombie.*` and `botLines.human.*` are separate.

   An unknown code — or a side this build has never heard of — renders as nothing and the caller
   drops the bubble rather than showing an empty one: a server that has learned to say something
   this build has never heard of is the ordinary state of affairs for a few minutes after a
   deploy. */

import i18n from "src/i18n"

// What this build knows how to read. The backend's `CODE_*` constants are the same four.
export const BOT_LINE_CODES = ["crown_taken", "crown_lost", "battle_won", "battle_lost"]

/* One glyph per code, this client's choice — the wire carries neither the emoji nor the words.
   Read from the bot's side of it: a crown taken is *its* triumph, a crown lost its disaster. */
const BOT_LINE_EMOJI = {
  crown_taken: "👑",
  crown_lost: "🏳️",
  battle_won: "⚔️",
  battle_lost: "💀",
}

export const botLineEmoji = (code) => BOT_LINE_EMOJI[code] || "•"

export const botLineText = (code, team) => {
  if (!code) return ""
  return i18n.t(`botLines.${team}.${code}`, { defaultValue: "" })
}

export default botLineText
